import React from "react";
import PropTypes from "prop-types";

const FinalViewWithoutRating = props => {
  const buClass = props.businessUnit === 2 ? "light-red-gradient" : "light-blue-gradient";
  return /*#__PURE__*/React.createElement("div", {
    id: "chat-view",
    className: "final-view-no-rating"
  }, /*#__PURE__*/React.createElement("h3", null, "Thanks for chatting with us today!"), /*#__PURE__*/React.createElement("div", {
    className: "section final-message"
  }, /*#__PURE__*/React.createElement("p", null, "We hope we were able to answer all your questions. If you have any further inquiries, please don't hesitate to contact us again."), /*#__PURE__*/React.createElement("p", null, "Have a great day!")), /*#__PURE__*/React.createElement("div", {
    className: "section button-container"
  }, /*#__PURE__*/React.createElement("button", {
    className: `button ${buClass}`,
    onClick: props.onButtonClick
  }, "CLOSE")));
};

FinalViewWithoutRating.propTypes = {
  businessUnit: PropTypes.number,
  onButtonClick: PropTypes.func
};
export default FinalViewWithoutRating;